/** 系统标签接口（POST baseURL + label/list/page） */
import request, { IWorkspaceResponse } from '/@/api/http/request'

/** 分页查询标签请求体 */
export interface LabelListPageParams {
  labelEN?: string
  labelCn?: string
  size: number
  page: number
}

/** 标签列表项 */
export interface LabelItem {
  id: number
  labelEn: string
  labelCn: string
  createTime: string
  updateTime: string
}

/** 分页查询返回 data（含 list、total 及分页导航字段） */
export interface LabelListPageData {
  total: number
  list: LabelItem[]
  page_num: number
  page_size: number
  size: number
  start_row: number
  end_row: number
  pages: number
  pre_page: number
  next_page: number
  is_first_page: boolean
  is_last_page: boolean
  has_previous_page: boolean
  has_next_page: boolean
  navigate_pages: number
  navigatepage_nums: number[]
  navigate_first_page: number
  navigate_last_page: number
}

/** 分页查询标签列表 */
export const getLabelListPage = async function (
  body: LabelListPageParams
): Promise<IWorkspaceResponse<LabelListPageData>> {
  const url = 'label/list/page'
  const result = await request.post(url, body)
  return result.data
}

/** 新增标签请求体（字段名与后端一致） */
export interface LabelCreateParams {
  labelEN: string
  labelCN: string
}

/** 新增标签，成功时 data 为新建记录 id */
export const createLabel = async function (
  body: LabelCreateParams
): Promise<IWorkspaceResponse<number>> {
  const url = 'label/create'
  const result = await request.post(url, body)
  return result.data
}

/** 删除标签请求体（字段名与后端一致） */
export interface LabelDeleteParams {
  labelEN: string
}

/** 删除标签，成功时 data 为影响行数 */
export const deleteLabel = async function (
  body: LabelDeleteParams
): Promise<IWorkspaceResponse<number>> {
  const url = 'label/delete'
  const result = await request.post(url, body)
  return result.data
}

/** 修改标签请求体（英文标识用于定位记录，业务上通常仅允许改中文名） */
export interface LabelUpdateParams {
  labelEN: string
  labelCN: string
}

/** 修改标签，成功时 data 为影响行数 */
export const updateLabel = async function (
  body: LabelUpdateParams
): Promise<IWorkspaceResponse<number>> {
  const url = 'label/update'
  const result = await request.post(url, body)
  return result.data
}